import request from "@/utils/request";

// 获取支付宝商户号列表
export function getZfbMerchantListApi(data) {
  return request({
    url: "/admin/customer_complaint/alipay/menu",
    method: "get",
    params: data
  });
}

// 获取支付宝投诉状态
export function getZfbComplaintStatusApi(data) {
  return request({
    url: "/admin/customer_complaint/alipay/list_status_option",
    method: "get",
    params: data
  });
}

// 支付宝客诉列表数据
export function getZfbComplaintListApi(data) {
  return request({
    url: "/admin/customer_complaint/alipay/get_list",
    method: "get",
    params: data
  });
}

// 支付宝客诉详情
export function getZfbComplaintDetailApi(data) {
  return request({
    url: "/admin/customer_complaint/alipay/get_info",
    method: "get",
    params: data
  });
}

// 支付宝客诉完成处理
export function handleZfbComplaintFinishApi(data) {
  return request({
    url: "/admin/customer_complaint/alipay/finish_deal",
    method: "post",
    data: data
  });
}

// 客诉上传图片
export function handleZfbComplaintUploadImageApi(data) {
  return request({
    url: "/admin/customer_complaint/alipay/file_upload",
    method: "post",
    data: data
  });
}

// 回复用户 - 客诉留言
export function handleZfbComplaintReplayUserApi(data) {
  return request({
    url: "/admin/customer_complaint/alipay/reply_send",
    method: "post",
    data: data
  });
}

// 处理记录
export function handleZfbComplaintRecordsApi(data) {
  return request({
    url: "/admin/customer_complaint/alipay/get_deal_log",
    method: "get",
    params: data
  });
}

// 微信商户号 --- start
export function getWxMerchantOptionsApi(data) {
  return request({
    url: "/admin/wechat_mch_option",
    method: "get",
    params: data
  });
}

// 获取微信商户投诉列表
export function getWxMerchantComplaintListApi(data) {
  return request({
    url: "/admin/wechat_mch_complaint_list",
    method: "post",
    data: data
  });
}

// 商户号投诉详情
export function getWxMerchantComplaintDetailApi(data) {
  return request({
    url: "/admin/wechat_mch_complaint_detail",
    method: "post",
    data: data
  });
}

// 处理回复用户
export function wxMerchantComplaintReplayUserApi(data) {
  return request({
    url: "/admin/wechat_mch_complaint_reply",
    method: "post",
    data: data
  });
}

// /微信商户总体投诉数据
export function wxMerchantComplaintOverviewDataApi(data) {
  return request({
    url: "/admin/wechat_mch_complaint_data",
    method: "post",
    data: data
  });
}

// 确认是否处理完成
export function wxMerchantCompleteApi(data) {
  return request({
    url: "/admin/wechat_mch_complaint_complete",
    method: "post",
    data: data
  });
}

// 微信飞书通知商户下拉
export function wxMerchantFsMotifyOptionsApi(data) {
  return request({
    url: "/admin/wechat_mch_check_option",
    method: "get",
    params: data
  });
}

// 微信飞书通知配置保存
export function wxMerchantFsMotifySaveApi(data) {
  return request({
    url: "/admin/wechat_mch_check_save",
    method: "post",
    data: data
  });
}

// 微信商户号 --- end